<template>
	<div>
		<compWrapper :title="$t('fbb.headlogistics.base_info', { defaultValue: '基础信息' })" theme="primary">
			<compFormQuery class="margin-layout" :formdata="getBase" :value="formData"></compFormQuery>
		</compWrapper>
		<compWrapper :title="$t('fbb.billing.feedetail', { defaultValue: '费用明细' })" theme="primary">
			<compTablelist class="margin-layout" :columns="getColumns" v-bind="getCostTableProps"></compTablelist>
			<vButton slot="footer" @click="cancel">{{$t('global.common.return', { defaultValue: "返回" })}}</vButton>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>
<script>

import { HttpExtraService, HttpMaterialCost, HttpQueryBillDetail, HttpWarehouseCost, HttpDistribution, HttpStorageCost, HttpAdjustAccountCost } from '@/service/billing';
import { mapGetters } from 'vuex';
import mixin from '../../mixin';
export default {
	mixins: [mixin],
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormQuery: () => import('@components/templates/formquery'),
		compLog: () => import('@components/templates/log'),
		compTablelist: () => import("@components/templates/tablelist"),
	},
	data() {
		return {
			loading: false,
			formData: {},
			datalist: [],
			type: this.$route.query.type,
			id: this.$route.query.id,
			parentId: this.$route.query.parentId,
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
		...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList']),
		//费用详情列表属性
		getCostTableProps() {
			const typeMap = {
				1: HttpWarehouseCost,
				2: HttpDistribution,
				3: HttpExtraService,
				4: HttpStorageCost,
				5: HttpMaterialCost,
				6: HttpAdjustAccountCost,
			}
			return {
				initFormData: {
					'search[EQ_billId]': this.parentId,
				},
				startUp: true,
				ajaxRequest: typeMap[this.type],
			};
		},
		getBase() {
			return [
				{
					label: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
					key: 'billNo',
				}, {
					label:  this.$t('fbb.alloment.order_status', { defaultValue: '状态' }),
					key: 'billStatus',
					valueText: this.formData.billStatus == 1 ? this.$t('fbb.headlogistics.confirmmed', { defaultValue: '已确认' }) :  this.$t('erp.distribution.created', { defaultValue: '已创建' })
				}, {
					label: this.$t('fbb.inbound.client_organization', { defaultValue: "客户" }),
					key: 'organizationName',
					// options: this.getBillcusorgList
				},
				// {
				// 	label: '仓库',
				// 	key: 'orgWarehouseCode',
				// 	// options: this.getBillcusWareList
				// },
				{
					label:  this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' }),
					// key: 'totalCost',
					valueText: this.formData.totalCost + ' ' + this.formData.currency
				}, {
					label: this.$t('fbb.billmanage.bill_date', { defaultValue: '月份' }),
					key: 'billingDate',
				}, {
					label: this.$t('fbb.adjustment.bill_type', { defaultValue: '费用类型' }),
					key: 'costType',
					options: this.getCostType
				},

			]
		},
		//按照类型获取 columns
		getColumns() {
			const typeMap = {
				1: 'getWarehouseColumns',
				2: 'getDistributionColumns',
				3: 'getServiceColumns',
				4: 'getStorageColumns',
				5: 'getMaterialColumns',
				6: 'getAccountColumns',
			};
			return this[typeMap[this.type]]
		},
		//业务类型
		getBusinessType() {
			return [{
				label: this.$t('fbb.adjustment.list_transfer', { defaultValue: '中转费用' }),
				value: '1'
			}, {
				label: this.$t('fbb.adjustment.list_common', { defaultValue: '一般入库' }),
				value: '2'
			}, {
				label: this.$t('fbb.adjustment.list_sale', { defaultValue: '销售订单' }),
				value: '3'
			}, {
				label:  this.$t('fbb.adjustment.list_storage', { defaultValue: '仓储' }),
			}, {
				label:  this.$t('bi.work.task_category_other', { defaultValue: '其他' }),
				value: '5'
			}, {
				label: this.$t('fbb.adjustment.list_sub', { defaultValue: '调拨' }),
				value: '6'
			}, {
				label: this.$t('fbb.adjustment.list_return', { defaultValue: '退货' }),
				value: '7'
			}, {
				label: this.$t('fbb.alloment.all', { defaultValue: 'All' }),
				value: '10'
			}, {
				label: this.$t('fbb.adjustment.list_nosource', { defaultValue: '无来源入库' }),
				value: '11'
			},{
				label:  this.$t('fbb.adjustment.list_destroy', { defaultValue: '销毁单' }),
				value: '20'
			}, {
				label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
				key: 'orgWarehouseCode',
			}]
		},
		//仓库作业费
		getWarehouseColumns() {
			return [
				{
					title: this.$t('fbb.costmanage.work_type', { defaultValue: '业务类型' }),
					key: 'businessType',
					render: (h, { row }) => {
						const businessType = row.businessType
						const { label } = this.getBusinessType.find(function (item) {
							return item.value == businessType
						}) || {};
						return label || '--'
					}
				},
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                	key: 'orgWarehouseCode',
                	// options: this.getBillcusWareList
                },
				{
					title: this.$t('fbb.adjustment.list_firstcategory', { defaultValue: '一级分类' }),
					key: 'firstBillingCategoryName'
				},
				{
					title: this.$t('fbb.adjustment.list_secondcategory', { defaultValue: '二级分类' }),
					key: 'secondBillingCategoryName'
				},
				{
					title: this.$t('fbb.adjustment.list_thirdcategory', { defaultValue: '三级分类' }),
					key: 'thirdBillingCategoryName'
				},
				{
					title: this.$t('fbb.adjustment.list_rate', { defaultValue: '费率' }),
					key: 'rate'
				},
				{
					title: this.$t('erp.b2c.quantity', { defaultValue: '数量' }),
					key: 'count'
				},
				{
					title: this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' }),
					key: 'cost'
				},
				{
					title: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
					key: 'relOrderNo'
				},
				{
					title:  this.$t('fbb.costmanage.distinguish_number', { defaultValue: '识别号' }),
					key: 'sourceNo'
				},
				{
					title:  this.$t('fbb.headlogistics.container_number', { defaultValue: '集装箱号' }),
					key: 'containerNo'
				},
				{
					title:  this.$t('fbb.expresspackage.erp_sku', { defaultValue: 'SKU' }),
					key: 'relSku'
				},
				{
					title: this.$t('global.common.line', { defaultValue: '项目' }),
					key: 'lineId',
					render: (h, { row }) => {
						const { label = '' } = this.getCusproductList.find(function (item) {
							return item.value == row.lineId
						}) || {};
						return label;
					}
				},
				{
					title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
					key: 'updatedAt'
				}
			]
		},
		// 配送费
		getDistributionColumns() {
			return [
			    {
					title: this.$t('fbb.shippment.package', { defaultValue: 'Tracking' }),
					key: '关联单号'
				},
				{
					title: this.$t('fbb.alloment.carrier_server', { defaultValue: '承运商服务' }),
					key: 'carrierServiceCode'
				},
				{
					title: this.$t('fbb.adjustment.list_costname', { defaultValue: '收费项' }),
					key: 'costName'
				},
				{
					title: this.$t('fbb.adjustment.list_cost', { defaultValue: '收费金额' }),
					key: 'cost'
				},
				{
					title:  this.$t('global.common.currency', { defaultValue: '币种' }),
					key: 'currency'
				},
				{
					title:  this.$t('global.common.line', { defaultValue: '项目' }),
					key: 'lineId',
					render: (h, { row }) => {
						const { label = '' } = this.getCusproductList.find(function (item) {
							return item.value == row.lineId
						}) || {};
						return label;
					}
				},
				{
					title: this.$t('fbb.adjustment.list_sourceno', { defaultValue: '关联单号' }),
					key: 'sourceNo'
				},
				{
					title: this.$t('fbb.adjustment.list_createdat', { defaultValue: '收费时间' }),
					key: 'createdAt'
				}
			]
		},
		// 仓储
		getStorageColumns() {
			return [
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    key: 'orgWarehouseCode',
                    // options: this.getBillcusWareList
                },
				{
					title: this.$t('fbb.expresspackage.erp_sku', { defaultValue: 'SKU' }),
					key: 'sku'
				},
				{
					title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
					// key: 'inventoryType',
					render: (h, { row }) => {
						switch (row.inventoryType) {
							case 'CAN_SALE': return this.$t('fbb.inbound.available_stock', { defaultValue: '可售库存' }); break;
							case 'NO_SALE': return this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' }); break;
						}
					}
				},
				{
					title: this.$t('fbb.inbound.batch_no', { defaultValue: '批次号' }),
					key: 'batchNo'
				},
				{
					title: this.$t('fbb.adjustment.list_storageday', { defaultValue: '存储天数' }),
					key: 'storageDays'
				},
				{
					title: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' }),
					key: 'stock'
				},
				{
					title:  this.$t('fbb.adjustment.list_billnum', { defaultValue: '计费量' }),
                    key: 'billNum',
                    render: (h, { row }) => {
                        let unitArr = {
                            'BILL_UNIT_CUBIC_METER': this.$t('fbb.adjustment.list_meter', { defaultValue: '立方米' }),
                            'BILL_UNIT_CUBIC_FOOT': this.$t('fbb.adjustment.list_foot', { defaultValue: '立方英尺' })
                        }
                        return (
                            <div>
                                {row.billNum} * {unitArr[row.unit]}
                            </div>
                        )
                    }
				},
				{
					title: this.$t('fbb.adjustment.list_rate', { defaultValue: '费率' }),
					key: 'rate'
				},
				{
					title:  this.$t('fbb.adjustment.list_modulus', { defaultValue: '计费系数' }),
					key: 'modulus'
				},
				{
					title: this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' }),
					key: 'totalCost'
				},
				{
					title: this.$t('global.common.currency', { defaultValue: '币种' }),
					key: 'currency'
				},
				// {
				// 	title: "长(cm)",
				// 	key: 'length'
				// },
				// {
				// 	title: "宽(cm)",
				// 	key: 'width'
				// },
				// {
				// 	title: "高(cm)",
				// 	key: 'height'
				// },
				{
					title: this.$t('fbb.adjustment.list_size', { defaultValue: '尺寸(cm*cm*cm)' }),
					key: "length",
					render(h, { row }) {
						return `${row.length} * ${row.width} * ${row.height}`
					}
				},
				{
					title: this.$t('global.common.line', { defaultValue: '项目' }),
					key: 'lineId',
					render: (h, { row }) => {
						const { label = '' } = this.getCusproductList.find(function (item) {
							return item.value == row.lineId
						}) || {};
						return label;
					}
				},
				{
					title: this.$t('fbb.adjustment.list_snapshotat', { defaultValue: '快照日期' }),
					key: 'snapshotAt'
				},
				{
					title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
					key: 'updatedAt'
				}
			]
		},
		// 调账
		getAccountColumns() {
			return [
				{
					title: this.$t('fbb.adjustment.bill_type', { defaultValue: '费用类型' }),
					render: (h, { row }) => {
						const billingType = row.billingType
						const { label } = this.getCostType.find(function (item) {
							return item.value == billingType
						}) || {};
						return label || '--'
					}
				},
				{
					title: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
					key: 'billingOrderNo'
				},
				{
					title: this.$t('fbb.adjustment.type', { defaultValue: '调账类型' }),
					// key:'type'
					render: (h, { row }) => {
						return row.type == 1 ? this.$t('fbb.adjustment.list_adjustreturn', { defaultValue: '调账返还' }) : this.$t('fbb.adjustment.list_adjustdis', { defaultValue: '调账扣减' })
					}
				},
				{
					title: this.$t('fbb.adjustment.amount', { defaultValue: '调账金额' }) ,
					key: 'amount'
				},
				{
					title: this.$t('global.common.currency', { defaultValue: '币种' }),
					key: 'currency'
				},
				{
					title: this.$t('fbb.adjustment.remark', { defaultValue: '调账说明' }),
					key: 'remark'
				},
				{
					title: this.$t('fbb.adjustment.created_name', { defaultValue: '创建人' }),
					key: 'createdName'
				},
				{
					title:this.$t('	global.common.createdtime', { defaultValue: '创建时间' }), 
					key: 'createdAt'
				}
			]
		},
		// 查看增值服务费
		getServiceColumns() {
			return [
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    key: 'orgWarehouseCode',
                    // options: this.getBillcusWareList
                },
				{
					title: this.$t('fbb.costmanage.work_type', { defaultValue: '业务类型' }),
					key: 'businessType',
					render: (h, { row }) => {
						const businessType = row.businessType
						const { label } = this.getBusinessType.find(function (item) {
							return item.value == businessType
						}) || {};
						return label || '--'
					}
				}, {
					title: this.$t('fbb.costmanage.things', { defaultValue: '事务项' }),
					key: 'transactionCode'
				}, {
					title: this.$t('fbb.adjustment.list_rate', { defaultValue: '费率' }),
					key: 'baseRate'
				}, {
					title:  this.$t('erp.b2c.quantity', { defaultValue: '数量' }),
					key: 'qty'
				}, {
					title: this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' }),
					key: 'totalCost'
				}, {
					title: this.$t('global.common.currency', { defaultValue: '币种' }),
					key: 'currency'
				}, {
					title: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
					key: 'orderNo'
				}, {
					title: this.$t('fbb.costmanage.distinguish_number', { defaultValue: '识别号' }),
					key: 'sourceNo'
				}, {
					title: this.$t('fbb.expresspackage.erp_sku', { defaultValue: 'SKU' }),
					key: 'sku'
				}, {
					title: this.$t('global.common.line', { defaultValue: '项目' }),
					key: 'lineId',
					render: (h, { row }) => {
						const { label = '' } = this.getCusproductList.find(function (item) {
							return item.value == row.lineId
						}) || {};
						return label;
					}
				}, {
					title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
					key: 'updatedAt'
				}
			]
		},
		//查看包材计费单
		getMaterialColumns() {
			return [
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    key: 'warehouseCode',
                    // options: this.getBillcusWareList
                },
			    {
				title:  this.$t('fbb.costmanage.material', { defaultValue: '包材' }),
				key: 'materialName'
			}, {
				title: this.$t('fbb.adjustment.list_rate', { defaultValue: '费率' }),
				key: 'baseRate'
			}, {
				title:  this.$t('erp.b2c.quantity', { defaultValue: '数量' }),
				key: 'qty'
			}, {
				title: this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' }),
				key: 'cost'
			}, {
				title: this.$t('global.common.currency', { defaultValue: '币种' }),
				key: 'currency'
			}, {
				title: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
				key: 'orderNo'
			}, {
				title: this.$t('fbb.inbound.logistics_singleno', { defaultValue: 'Tracking No.' }),
				key: 'trackingNo'
			}, {
				title: this.$t('global.common.line', { defaultValue: '项目' }),
				key: 'lineId',
				render: (h, { row }) => {
					const { label = '' } = this.getCusproductList.find(function (item) {
						return item.value == row.lineId
					}) || {};
					return label;
				}
			}, {
				title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
				key: 'updatedAt'
			}
			]
		},
	},
	methods: {
		// getCostDetail() {
		// 	const typeMap = {
		// 		// 1: 'getWarehouseDetail',
		// 		3: 'getServiceDetail',
		// 		4: 'getStorageDetail',
		// 		5: 'getMaterialDetail',
		// 		// 6: 'getAccountDetail',
		// 	};
		// 	const ajax = typeMap[this.type];
		// 	if (ajax) this[ajax]();
		// },
		//仓库作业费
		// getWarehouseDetail() {
		// 	this.loading = true;
		// 	HttpWarehouseCost({ 'search[EQ_billId]': this.parentId,page:1,rows:1000 }).then(res => {
		// 		this.loading = false;
		// 		this.datalist = res.data.content;
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		//仓储
		// getStorageDetail() {
		// 	this.loading = true;
		// 	HttpStorageCost({ 'billId': this.parentId }).then(res => {
		// 		this.loading = false;
		// 		this.datalist = res.data;
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		// //增值服务
		// getServiceDetail() {
		// 	this.loading = true;
		// 	HttpExtraService({ billId: this.parentId }).then(res => {
		// 		this.loading = false;
		// 		this.datalist = res.data;
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		// //包材
		// getMaterialDetail() {
		// 	this.loading = true;
		// 	HttpMaterialCost({ billId: this.parentId }).then(res => {
		// 		this.loading = false;
		// 		this.datalist = res.data;
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		//调账
		// getAccountDetail() {
		// 	this.loading = true;
		// 	HttpAdjustAccountCost({ 'search[EQ_billId]': this.parentId }).then(res => {
		// 		this.loading = false;
		// 		this.datalist = res.data.content
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		//账单明细请求头部详情页
		getDetail() {
			// this.loading = true;
			// this.getCostDetail();
			HttpQueryBillDetail({ id: this.id }).then(res => {
				this.formData = res.data;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		cancel() {
			this.$router.push({
				name: this.$route.name.slice(0, -1),
				query: {
					id: this.parentId
				}
			})
		},
	}
};
</script>
